<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-select multiple :options="options" label="id" v-model="innerValue" class="multi-tags-selector"
              :close-on-select="false" :searchable="false" ref="selector">
        <template v-slot:option="option">
            <span class="tag-item" :style="{'background-color': option.color}">{{option.name}}</span>
        </template>
        <template v-slot:no-options><div></div></template>
        <template v-slot:selected-option="option">
            <span class="tag-item" style="margin: 2px" :style="{'background-color': option.color}">{{option.name}}</span>
        </template>
    </v-select>
</template>

<script>
    export default {
        name: "MultiTagsSelector",
        props: ["tags", "value"],
        data() {
            return {
                innerValue: [],
            }
        },
        computed: {
            options() {
                return this.tags.filter(t => !this.innerValue.find(v => v.id === t.id));
            },
        },
        methods: {
            syncIn(val) {
                let innerValue = val.map(x => this.tags.find(t => t.id === x)).filter(x => x);
                if (JSON.stringify(this.innerValue.map(x => x)) !== JSON.stringify(innerValue)) {
                    this.innerValue = innerValue;
                }
            },
            deselect(option) {
                this.$refs.selector.deselect(option);
            },
        },
        watch: {
            value(val) {
                this.syncIn(val);
            },
            innerValue(val) {
                this.$emit('input', val.map(x => x.id));
            }
        },
        created() {
            this.syncIn(this.value);
        }
    }
</script>

<style>
    .multi-tags-selector .vs__dropdown-menu {
        display: flex;
        flex-wrap: wrap;
    }

    .multi-tags-selector .vs__dropdown-option {
        padding: 3px 10px;
    }
</style>

<style scoped>
    .tag-item {
        color: white;
        padding: 0 5px;
    }
</style>
